import type { CSSProperties } from 'react';
import NavbarCollapseIconSvg from '../../assets/icons/navbar_collapse.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const NavbarCollapseIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <NavbarCollapseIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default NavbarCollapseIcon;
